import {
  CustomerFeedbacksStatisticsState,
  REQUEST_CUSTOMERFEEDBACKSTATISTICS,
  REQUEST_CUSTOMERFEEDBACKSTATISTICS_DONE
} from "./types";

const initialState: CustomerFeedbacksStatisticsState = {
  isLoading: true,
  customerFeedbackStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_CUSTOMERFEEDBACKSTATISTICS:
      return {
        isLoading: true,
        customerFeedbackStatistics: action.payload
      };
    case REQUEST_CUSTOMERFEEDBACKSTATISTICS_DONE:
      return {
        isLoading: false,
        customerFeedbackStatistics: action.payload
      };
    default:
      return state;
  }
}
